export * from './api';

export enum LSPTypes {
  EMPLOYER_OF_RECORD = 'lsp:employer-of-record',
  PAYROLL_PROVIDER = 'lsp:payroll-provider',
}
